/**
 * Deep link wa.me - normalizzazione telefono e apertura WhatsApp.
 * Usato per invio manuale (credenziali, messaggi marketing 1:1).
 * Non usa WhatsApp Business API.
 */

/** @param {string|null|undefined} phone */
export function normalizePhoneForWhatsApp(phone) {
  let digits = String(phone ?? '').replace(/\D/g, '');
  if (digits.length === 0) return '';
  if (digits.startsWith('00')) digits = digits.replace(/^00/, '');
  // Italia: prefisso 39 se mancante (9-10 cifre nazionali)
  if (digits.startsWith('39') && digits.length >= 11) return digits;
  if (digits.length >= 9 && digits.length <= 10) return `39${digits}`;
  return digits;
}

/** @param {string|null|undefined} phone @param {string} [text] */
export function buildWhatsAppUrl(phone, text = '') {
  const phoneNorm = normalizePhoneForWhatsApp(phone);
  if (!phoneNorm) return null;
  const base = `https://wa.me/${phoneNorm}`;
  const msg = String(text ?? '').trim();
  return msg ? `${base}?text=${encodeURIComponent(msg)}` : base;
}

/** @param {string|null|undefined} phone @param {string} [text] @returns {boolean} */
export function openWhatsApp(phone, text = '') {
  const url = buildWhatsAppUrl(phone, text);
  if (!url) return false;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
